import React from 'react';

import { MultiselectField, Label } from 'components';
import { v4 as uuid } from 'uuid';

import ValidationMessage from 'components/general/ValidationMessage';

type Schema = {
  label: string;
  value: string;
  isDisabled: string;
};

type OwnProps = {
  /** callback for user */
  onChange: (options: any[]) => void;
  /** identifier */
  name?: string;
  /** select field items */
  items: any[];
  /** schema to map data  */
  schema?: Schema;
  /** placeholder */
  placeholder: string;
  /** max height for menu */
  isSearchable: boolean;
  value: any[];
  className?: string;
  errors?: string[];
  modifyValue?: boolean;
  label?: string;
  disabled?: boolean;
  testId?: string;
  doTranslate?: boolean;
};

type Props = OwnProps;

export function StaffTeamsMultiSelectDropdown({
  items,
  name = `MultiselectField-${uuid()}`,
  value = [],
  onChange,
  placeholder = 'Select Option',
  schema = {
    label: 'label',
    value: 'value',
    isDisabled: 'isDisabled',
  },
  isSearchable = true,
  errors,
  className,
  disabled = false,
  label,
  testId,
  doTranslate = true,
}: Props) {
  function constructOption(item: any) {
    return {
      label: item[schema.label],
      value: item[schema.value],
      isDisabled: item[schema.isDisabled],
    };
  }

  return (
    <div className={className} data-test={testId}>
      {label && <Label mt={0}>{label}</Label>}

      <MultiselectField
        value={value}
        name={name}
        isSearchable={isSearchable}
        onChange={onChange}
        placeholder={placeholder}
        items={items.map(constructOption)}
        disabled={disabled}
        truncateSelectedItems
        doTranslation={doTranslate}
      />
      <ValidationMessage errors={errors} />
    </div>
  );
}
